export const environment = {
    production: true,
    getterLink:"https://getter.test.jo/api",
    govnet:"https://stagingapp.govnet.gov.jo/api",
    // getterLink:"http://appv4.sanad.gov.jo/api",
    // govnet:"https://stagingapp.govnet.gov.jo/api",
    oldWebsite:"https://eservices.moin.gov.jo",

    MainPath:"HCD", //To chnage the url per project
    LogoPicSrc:"../../../assets/images/hcd.png",
    backGroundImageSrc:"../../../assets/images/hcd_background.jpeg",
    NameOfProject:"../assets/languages/hcd/",
    UpFooterLogoPicSrc:"../../../assets/images/hcd.png", 
    DownFooterLogoPicSrc:"../../../assets/images/hcd.png",
    Title:"الخدمات الالكترونية - المجلس الأعلى لحقوق الأشخاص ذوي الإعاقة",
    SectionId: "66ab45a851290e0b14788076",

};
